export default class BookingState {}
